enum EnumResponsabilidade {
  INDICADOR = 1,
  REPRESENTANTE = 2,
  ESTABELECIMENTO = 3,
  RESPONSAVEL = 4,
  INCENTIVADOR = 5,
}

export default EnumResponsabilidade;
